import json2mq from 'json2mq'

const breakpoints = {
  xs: json2mq({ minWidth: 0 }),

  s: json2mq({ minWidth: 843 }),
  fromS: json2mq({ minWidth: 843 }),
  /** maxWidth: 842px */
  toS: json2mq({ maxWidth: 842 }),

  m: json2mq({ minWidth: 1024 }),
  fromM: json2mq({ minWidth: 1024 }),
  toM: json2mq({ maxWidth: 1023 }),

  l: json2mq({ minWidth: 1200 }),
  fromL: json2mq({ minWidth: 1200 }),
  toL: json2mq({ maxWidth: 1199 }),
}

function toRem(pixelValue: number): string {
  return `${pixelValue / 16}rem`
}

export { breakpoints, toRem }
